import React from 'react';
import { twMerge } from 'tailwind-merge';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  as?: 'div' | 'section' | 'article' | 'aside';
}
export function Card({
  children,
  className,
  as = 'div'
}: CardProps) {
  const Tag = as;
  return <Tag className={twMerge('rounded-2xl border border-ink-200 bg-white shadow-card', className)} data-id="element-366" data-mp="8a3sppdll2g5">
      {children}
    </Tag>;
}